import React from "react";
import { Building2, Wrench, Repeat2, Monitor, Recycle } from "lucide-react";

import { ShopifyMark } from "./icons";

const AUDIENCES = [
  {
    icon: Building2,
    title: "ITAD companies",
    body: "Process corporate IT assets with clearer erasure, assessment, reporting, and resale workflows.",
  },
  {
    icon: Wrench,
    title: "Refurbishers",
    body: "Move devices from intake to resale-ready faster with assessment, reimaging, grading, and inventory routing.",
  },
  {
    icon: Repeat2,
    title: "Buyback operators",
    body: "Connect trade-in intake with real device assessment, grading, pricing, and resale workflows.",
  },
  {
    icon: Monitor,
    title: "Corporate IT teams",
    body: "Prepare recovered devices for redeployment, resale, recycling, or vendor handoff.",
  },
  {
    icon: Recycle,
    title: "Recyclers & repair businesses",
    body: "Identify devices worth recovering, refurbishing, or reselling — and route the rest based on condition and replacement needs.",
  },
  {
    shopify: true,
    title: "Shopify store owners & ecommerce resellers",
    body: "Connect trade-in, buyback, and resale directly to your Shopify store — turn recovered devices into resale-ready listings backed by verified condition, grading, and evidence.",
  },
];

const WhoItsFor = () => {
  return (
    <section id="who" className="relative bg-white font-body">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:py-28">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-line bg-brand-bg px-3.5 py-1.5 text-xs font-medium uppercase tracking-[0.16em] text-brand-plum">
            Who it's for
          </span>
          <h2 className="mt-5 font-display text-3xl font-semibold leading-tight tracking-tight text-brand-plum sm:text-4xl lg:text-5xl">
            Built for Teams That Recover, Process, and Resell Devices
          </h2>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {AUDIENCES.map((a) => (
            <div
              key={a.title}
              className={`group flex flex-col rounded-2xl border p-6 transition-all hover:-translate-y-1 hover:shadow-xl hover:shadow-brand-plum/5 ${
                a.shopify
                  ? "border-brand-orchid/40 bg-gradient-to-br from-brand-wash to-white"
                  : "border-line bg-white hover:border-brand-orchid"
              }`}
            >
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand-wash ring-1 ring-brand-orchid/30">
                {a.shopify ? (
                  <ShopifyMark className="h-6 w-6" />
                ) : (
                  <a.icon className="h-6 w-6 text-brand-magenta" />
                )}
              </span>
              <h3 className="mt-4 font-display text-lg font-semibold text-brand-plum">{a.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted">{a.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoItsFor;
